// extracted by mini-css-extract-plugin
export default {"thankYou":"ThankYou_thankYou__eFJpH","actions":"ThankYou_actions__BmerQ","feedback":"ThankYou_feedback__nYXX6"};